// extracted by mini-css-extract-plugin
export default {"contenido":"Card_contenido__oJs+1"};